import React, { Component } from "react";
import Heart from "./Heart.jsx";
import "../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronDown,
    faHeart,
    faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Mobile from "../component/mobile";
import Cars from "../component/container/cars";
import OlxImage from "./olx-header.jpg";

import { Card, Sell } from "../component/product";

class Nav extends Component {
    render() {
        return (
            <nav>
                <ul>
                    <li>
                        <span>
                            ALL CATEGORIES
                            <button>
                                <FontAwesomeIcon
                                    className={"icon"}
                                    icon={faChevronDown}
                                />
                            </button>
                        </span>
                    </li>
                    <Link to="/mobile">
                        <li>Mobile Phones</li>
                    </Link>
                    <Link to="/cars">
                        {" "}
                        <li>Cars</li>
                    </Link>
                    <li>Motorcycles</li>
                    <li>Houses</li>
                    <li>TV-Video-Audio</li>
                    <li>Tablets</li>
                    <li>Land &amp; Plots</li>
                </ul>
            </nav>
        );
    }
}

class Ads extends Component {
    render() {
        return (
            <div>
                {/* navbar end */}
                <div className="bac-image">
                    <img src={OlxImage} alt="" />
                </div>
                <br />
                <br />
                <br />
                <center>
                    <div className="ads">
                        <img
                            src="https://tpc.googlesyndication.com/simgad/9395401322792855491?sqp=4sqPyQQ7QjkqNxABHQAAtEIgASgBMAk4A0DwkwlYAWBfcAKAAQGIAQGdAQAAgD-oAQGwAYCt4gS4AV_FAS2ynT4&rs=AOga4qmMqo-yL0who0OnSI_QsJIDyBBiAA"
                            alt=""
                        />
                    </div>
                    <br />
                </center>
                <Mobile />
            </div>
        );
    }
}

class Product extends Component {
    render() {
        let change = (e) => {
            console.log(e.target);
        };
        return (
            <div>
                <div className="main-boxes">
                    <div className="main-text">
                        <span>Fresh recommendations </span>
                    </div>
                    <div className="Cards">
                        <Card
                            price={"Rs 190"}
                            itemName={"Watch"}
                            imgLink={
                                "https://i.ytimg.com/vi/ETsekJKsr3M/maxresdefault.jpg"
                            }
                        />
                        <Card
                            price={"Rs 190"}
                            itemName={"Watch"}
                            imgLink={
                                "https://i.ytimg.com/vi/ETsekJKsr3M/maxresdefault.jpg"
                            }
                        />
                        <Card
                            price={"Rs 400"}
                            itemName={"Speaker"}
                            imgLink={
                                "https://elcopcbonline.com/photos/product/4/176/4.jpg"
                            }
                        />
                        <Card
                            price={"Rs 400"}
                            itemName={"Speaker"}
                            imgLink={
                                "https://elcopcbonline.com/photos/product/4/176/4.jpg"
                            }
                        />
                        <Card
                            price={"Rs 400"}
                            itemName={"Rolex"}
                            imgLink={
                                "https://www.roudstudio.com/images/works/product-photo/img01.jpg"
                            }
                        />
                        <Card
                            price={"Rs 400"}
                            itemName={"Rolex"}
                            imgLink={
                                "https://www.roudstudio.com/images/works/product-photo/img01.jpg"
                            }
                        />
                        <Card
                            price={"Rs 1,00000"}
                            itemName={"Iphone"}
                            imgLink={
                                "https://www.viagrapharma.com/uploads/product/red.jpeg"
                            }
                        />
                        <Card
                            price={"Rs 1,00000"}
                            itemName={"Iphone"}
                            imgLink={
                                "https://www.viagrapharma.com/uploads/product/red.jpeg"
                            }
                        />

                        <Sell />
                    </div>
                </div>
                <br />
                <br />
                <br />
                <center>
                    <button className="load">Load More</button>

                    <br />
                    <div className="ads-olx">
                        <img
                            className="olx-ads"
                            src="https://tpc.googlesyndication.com/simgad/18016187071986703145?sqp=4sqPyQQrQikqJwhfEAEdAAC0QiABKAEwCTgDQPCTCUgAUAFYAWBfcAJ4AcUBLbKdPg&rs=AOga4ql5e4DBQY0a8xs3Z-Aj7Bzbji8dpw"
                            alt=""
                        />
                    </div>
                </center>{" "}
            </div>
        );
    }
}

export { Nav, Ads, Product };
